// extracted by mini-css-extract-plugin
module.exports = {"input":"FileUpload_input__3ePzM"};